module.exports = __webpack_public_path__ + "static/media/c4bannerModul2_small.b958a73a.jpg";